/* Smoking Cats Dawn Kit small helpers */
(() => {
  function initProductGalleries(root = document) {
    root.querySelectorAll('[data-sc-product-gallery]').forEach((gallery) => {
      const main = gallery.querySelector('[data-sc-main-image]');
      const thumbs = gallery.querySelectorAll('[data-sc-thumb]');

      if (!main || !thumbs.length) return;

      thumbs.forEach((button) => {
        if (button.dataset.scGalleryReady === 'true') return;

        button.dataset.scGalleryReady = 'true';

        button.addEventListener('click', () => {
          const src = button.getAttribute('data-src');

          if (!src) return;

          main.src = src;

          const srcset = button.getAttribute('data-srcset');

          if (srcset) {
            main.srcset = srcset;
          }

          main.alt = button.getAttribute('data-alt') || '';

          thumbs.forEach((thumb) => {
            thumb.setAttribute('aria-current', 'false');
          });

          button.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function submitFacetForm(form) {
    if (!form || form.dataset.scSubmitting === 'true') return;

    form.dataset.scSubmitting = 'true';
    form.classList.add('is-loading');
    form.setAttribute('aria-busy', 'true');

    const url = new URL(window.location.href);
    const params = new URLSearchParams(new FormData(form));

    params.delete('page');

    url.search = params.toString();
    url.hash = '';

    window.location.assign(url.toString());
  }

  const priceTimers = new WeakMap();

  document.addEventListener('change', (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const form = target.closest('[data-sc-facet-form]');

    if (!form) return;

    if (target.matches('[data-sc-auto-submit]')) {
      submitFacetForm(form);
    }
  });

  document.addEventListener('input', (event) => {
    const target = event.target;

    if (
      !(target instanceof Element) ||
      !target.matches('[data-sc-price-input]')
    ) {
      return;
    }

    const form = target.closest('[data-sc-facet-form]');

    if (!form) return;

    window.clearTimeout(priceTimers.get(form));

    priceTimers.set(
      form,
      window.setTimeout(() => {
        submitFacetForm(form);
      }, 800)
    );
  });

  document.addEventListener('keydown', (event) => {
    const target = event.target;

    if (
      event.key !== 'Enter' ||
      !(target instanceof Element) ||
      !target.matches('[data-sc-price-input]')
    ) {
      return;
    }

    const form = target.closest('[data-sc-facet-form]');

    if (!form) return;

    event.preventDefault();
    window.clearTimeout(priceTimers.get(form));
    submitFacetForm(form);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initProductGalleries();
    });
  } else {
    initProductGalleries();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initProductGalleries(event.target);
  });
})();

/* SC mobile collection sidebar toggle */
(() => {
  function setSidebarState(button, sidebar, open) {
    sidebar.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');

    const label = button.querySelector(
      '[data-sc-mobile-sidebar-toggle-label]'
    );

    if (label) {
      label.textContent = open ? 'Hide filters' : 'Show filters';
    }
  }

  document.addEventListener('click', (event) => {
    const button =
      event.target instanceof Element
        ? event.target.closest('[data-sc-mobile-sidebar-toggle]')
        : null;

    if (!button) return;

    const sidebarId = button.getAttribute('aria-controls');
    const sidebar = sidebarId
      ? document.getElementById(sidebarId)
      : null;

    if (!sidebar) return;

    const open = button.getAttribute('aria-expanded') !== 'true';

    setSidebarState(button, sidebar, open);
  });

  window.addEventListener('resize', () => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    document
      .querySelectorAll('[data-sc-mobile-sidebar-toggle]')
      .forEach((button) => {
        const sidebarId = button.getAttribute('aria-controls');
        const sidebar = sidebarId
          ? document.getElementById(sidebarId)
          : null;

        if (!sidebar) return;

        sidebar.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');

        const label = button.querySelector(
          '[data-sc-mobile-sidebar-toggle-label]'
        );

        if (label) {
          label.textContent = 'Show filters';
        }
      });
  });
})();

/* SC product page variant boxes, price, SKU and availability */
(() => {
  const formatMoney = (cents, format) => {
    const amount = Number(cents || 0) / 100;

    const placeholder =
      /\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator)\s*\}\}/;

    const match = String(format || '${{amount}}').match(placeholder);
    const type = match ? match[1] : 'amount';

    let value;

    if (type === 'amount_no_decimals') {
      value = amount.toLocaleString('en-US', {
        maximumFractionDigits: 0
      });
    } else if (type === 'amount_with_comma_separator') {
      value = amount.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } else if (type === 'amount_no_decimals_with_comma_separator') {
      value = amount.toLocaleString('de-DE', {
        maximumFractionDigits: 0
      });
    } else {
      value = amount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    return String(format || '${{amount}}').replace(
      placeholder,
      value
    );
  };

  function initSCProduct(root = document) {
    root.querySelectorAll('[data-sc-product-root]').forEach((productRoot) => {
      if (productRoot.dataset.scProductReady === 'true') return;

      const variantsScript = productRoot.querySelector(
        '[data-sc-product-variants]'
      );

      const moneyScript = productRoot.querySelector(
        '[data-sc-product-money-format]'
      );

      const form = productRoot.querySelector(
        '[data-sc-product-form]'
      );

      const variantInput = productRoot.querySelector(
        '[data-sc-variant-id]'
      );

      if (!variantsScript || !form || !variantInput) return;

      let variants = [];
      let moneyFormat = '${{amount}}';

      try {
        variants = JSON.parse(
          variantsScript.textContent || '[]'
        );

        moneyFormat = moneyScript
          ? JSON.parse(
              moneyScript.textContent || '"${{amount}}"'
            )
          : moneyFormat;
      } catch (error) {
        return;
      }

      productRoot.dataset.scProductReady = 'true';

      const optionInputs = Array.from(
        productRoot.querySelectorAll('[data-sc-option-input]')
      );

      const addButton = productRoot.querySelector(
        '[data-sc-add-button]'
      );

      const addButtonText = productRoot.querySelector(
        '[data-sc-add-button-text]'
      );

      const currentPrice = productRoot.querySelector(
        '[data-sc-price-current]'
      );

      const comparePrice = productRoot.querySelector(
        '[data-sc-price-compare]'
      );

      const skuWrap = productRoot.querySelector(
        '[data-sc-product-sku-wrap]'
      );

      const skuText = productRoot.querySelector(
        '[data-sc-product-sku]'
      );

      const availability = productRoot.querySelector(
        '[data-sc-product-availability]'
      );

      const availabilityText = productRoot.querySelector(
        '[data-sc-product-availability-text]'
      );

      const inStockText =
        availabilityText &&
        !availability?.classList.contains('is-sold-out')
          ? availabilityText.textContent.trim()
          : 'In stock';

      const soldOutText =
        addButton && addButton.disabled
          ? addButtonText?.textContent.trim() || 'Sold out'
          : 'Sold out';

      const addText =
        addButton && !addButton.disabled
          ? addButtonText?.textContent.trim() || 'Add to cart'
          : 'Add to cart';

      const selectedOptions = () => {
        const values = [];

        productRoot
          .querySelectorAll('[data-sc-option-index]')
          .forEach((fieldset) => {
            const checked = fieldset.querySelector(
              '[data-sc-option-input]:checked'
            );

            values.push(checked ? checked.value : '');
          });

        return values;
      };

      const findVariant = () => {
        const values = selectedOptions();

        return variants.find((variant) =>
          values.every(
            (value, index) =>
              variant.options[index] === value
          )
        );
      };

      const updateOptionAvailability = () => {
        const selected = selectedOptions();

        optionInputs.forEach((input) => {
          const position =
            Number(input.dataset.optionPosition || 1) - 1;

          const possible = variants.some((variant) => {
            if (
              !variant.available ||
              variant.options[position] !== input.value
            ) {
              return false;
            }

            return selected.every((value, index) => {
              if (index === position) return true;

              return (
                !value ||
                variant.options[index] === value
              );
            });
          });

          const label = productRoot.querySelector(
            `label[for="${CSS.escape(input.id)}"]`
          );

          if (label) {
            label.classList.toggle(
              'is-unavailable',
              !possible
            );
          }

          input.setAttribute(
            'aria-disabled',
            possible ? 'false' : 'true'
          );
        });
      };

      const updateSelectedLabels = () => {
        productRoot
          .querySelectorAll('[data-sc-option-index]')
          .forEach((fieldset) => {
            const checked = fieldset.querySelector(
              '[data-sc-option-input]:checked'
            );

            const selectedLabel = fieldset.querySelector(
              '[data-sc-selected-option]'
            );

            if (selectedLabel && checked) {
              selectedLabel.textContent = checked.value;
            }
          });
      };

      const updateVariant = () => {
        const variant = findVariant();
        const available = Boolean(
          variant && variant.available
        );

        variantInput.value = variant ? variant.id : '';

        if (currentPrice) {
          currentPrice.textContent = variant
            ? formatMoney(variant.price, moneyFormat)
            : '';
        }

        if (comparePrice) {
          const showCompare = Boolean(
            variant &&
            variant.compare_at_price &&
            variant.compare_at_price > variant.price
          );

          comparePrice.hidden = !showCompare;

          comparePrice.textContent = showCompare
            ? formatMoney(
                variant.compare_at_price,
                moneyFormat
              )
            : '';
        }

        if (skuText && skuWrap) {
          skuText.textContent = variant?.sku || '';

          skuWrap.classList.toggle(
            'is-empty',
            !variant?.sku
          );
        }

        if (availability && availabilityText) {
          availability.classList.toggle(
            'is-sold-out',
            !available
          );

          availabilityText.textContent = available
            ? inStockText
            : soldOutText;
        }

        if (addButton && addButtonText) {
          addButton.disabled = !available;

          addButtonText.textContent = available
            ? addText
            : soldOutText;
        }

        updateSelectedLabels();
        updateOptionAvailability();

        if (variant) {
          const url = new URL(window.location.href);

          url.searchParams.set(
            'variant',
            variant.id
          );

          window.history.replaceState(
            {},
            '',
            url.toString()
          );
        }
      };

      optionInputs.forEach((input) => {
        input.addEventListener(
          'change',
          updateVariant
        );
      });

      updateVariant();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initSCProduct();
      }
    );
  } else {
    initSCProduct();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initSCProduct(event.target);
    }
  );
})();